async function init() {

    // eslint-disable-next-line
    const splideConstructor = await import('@splidejs/splide');

    const Splide = splideConstructor.Splide;

    const inspirationsSliders = document.querySelectorAll('.splide.js-inspirations-slider');

    const initInspirationsSlider = (el) => {

        const noOfSlides = el.querySelectorAll('.splide__slide').length;

        const slider = new Splide(el, {
            perPage: noOfSlides >= 4 ? 4 : noOfSlides,
            gap: 30,
            perMove: 1,
            flickPower: 100,
            breakpoints: {
                384: {
                    fixedWidth: undefined,
                },
                640: {
                    perPage: 1,
                    gap: 16,
                    arrows: false,
                    fixedWidth: noOfSlides >= 1 ? '345px' : undefined,
                },
                1400: {
                    perPage: noOfSlides >= 2 ? 2 : 1,
                    gap: 24,
                },
            },
            lazyLoad: 'nearby',
            arrows: noOfSlides > 4,
            focus: 0,
            fixedWidth: noOfSlides >= 4 ? '384px' : undefined,
            trimSpace: 'move',
            omitEnd: true,
        });

        slider.mount();

    };

    const initSliders = (sliders, initFunction) => {

        for (let i = 0; i < sliders.length; i++) {

            initFunction(sliders[i]);

        }

    };

    if (inspirationsSliders && inspirationsSliders.length > 0) {

        initSliders(inspirationsSliders, initInspirationsSlider);

    }

}

init();
